import { all, call, put, takeEvery } from 'redux-saga/effects'
import {
  deleteBibliotecaPregunta,
  getBibliotecasPreguntas,
  getBibliotecasPreguntasFiltered,
  insertBibliotecaPregunta,
  getBibliotecaPreguntaById,
  updateBibliotecaPregunta,
  getBibliotecaPreguntaProductoById,
  updateBibliotecasPreguntasProducto,
} from 'services/personalizacion'
import { messageType, putMessage } from 'utiles/mensaje'
import { actions } from './actions'

export function* GET_BIBLIOTECAS_PREGUNTAS() {
  try {
    const enumsData = yield call(getBibliotecasPreguntas)
    if (enumsData.ok) {
      yield put({
        type: actions.BIBLIOTECAS_PREGUNTAS_LOAD_SUCCEEDED,
        payload: enumsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBLIOTECAS_PREGUNTAS_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBLIOTECAS_PREGUNTAS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBLIOTECAS_PREGUNTAS_FILTERED(action) {
  try {
    const enumsData = yield call(getBibliotecasPreguntasFiltered, action.payload)
    if (enumsData.ok) {
      yield put({
        type: actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_SUCCEEDED,
        payload: enumsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBLIOTECA_PREGUNTA(action) {
  try {
    const resultData = yield call(deleteBibliotecaPregunta, action.payload)
    if (resultData.ok) {
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar')
      put({
        type: actions.BIBLIOTECA_PREGUNTA_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBLIOTECA_PREGUNTA(action) {
  try {
    const resultData = yield call(insertBibliotecaPregunta, action.payload)
    if (resultData.ok) {
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_INSERT_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al insertar')
      put({
        type: actions.BIBLIOTECA_PREGUNTA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al insertar')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBLIOTECA_PREGUNTA(action) {
  try {
    const resultData = yield call(updateBibliotecaPregunta, action.payload)
    if (resultData.ok) {
      putMessage(messageType.SUCCESS, 'OK')
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_UPDATE_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al insertar')
      put({
        type: actions.BIBLIOTECA_PREGUNTA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al insertar')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBLIOTECA_PREGUNTA_BY_ID(action) {
  try {
    const resultData = yield call(getBibliotecaPreguntaById, action.payload)
    if (resultData.ok) {
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_SUCCEEDED,
        payload: resultData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPREGUNTA_BY_PRODUCTO_ID(action) {
  try {
    const bibliotecasPreguntaData = yield call(getBibliotecaPreguntaProductoById, action.payload)
    if (bibliotecasPreguntaData.ok) {
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_SUCCEEDED,
        payload: bibliotecasPreguntaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Preguntas')
      put({
        type: actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Preguntas')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPREGUNTA_PRODUCTO(action) {
  try {
    const bibliotecasPreguntasByProducto = yield call(
      updateBibliotecasPreguntasProducto,
      action.payload,
    )
    if (bibliotecasPreguntasByProducto.ok) {
      putMessage(
        messageType.SUCCESS,
        'Bibliotecas de Preguntas modificada correctamente para este producto',
      )
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_SUCCEEDED,
        payload: bibliotecasPreguntasByProducto.data,
      })
    } else {
      putMessage(
        messageType.ERROR,
        'Error al modificar Bibliotecas de Preguntas para este producto',
      )
      yield put({
        type: actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Preguntas para este producto')
    yield all([
      put({
        type: actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBLIOTECAS_PREGUNTAS_LOAD_REQUESTED, GET_BIBLIOTECAS_PREGUNTAS),
    takeEvery(
      actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_REQUESTED,
      GET_BIBLIOTECAS_PREGUNTAS_FILTERED,
    ),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_DELETE_REQUESTED, DELETE_BIBLIOTECA_PREGUNTA),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_CREATE_REQUESTED, INSERT_BIBLIOTECA_PREGUNTA),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_REQUESTED, GET_BIBLIOTECA_PREGUNTA_BY_ID),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_UPDATE_REQUESTED, UPDATE_BIBLIOTECA_PREGUNTA),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_REQUESTED, GET_BIBPREGUNTA_BY_PRODUCTO_ID),
    takeEvery(actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_REQUESTED, UPDATE_BIBPREGUNTA_PRODUCTO),
  ])
}
